import { Paper, Typography, Box } from "@mui/material";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { Fab, CircularProgress, useTheme } from "@mui/material";
import { tokens } from "../theme";
import { green, teal } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

const MessageSent = ({ messageSent }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  if (messageSent) {
    navigate("/singlesend");
    return null;
  }

  const handleClick = () => {
    navigate("/singlesend");
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minHeight="70vh"
      position="relative"
    >
      <Paper
        elevation={12}
        sx={{
          background: `linear-gradient(135deg, ${green[200]} 20%, ${teal[200]} 80%)`,
          borderRadius: "20px",
        }}
      >
        <Box padding="10px" mx="20px" my="20px">
          <Box>
            <CheckCircleOutlinedIcon style={{ fontSize: "8rem" }} />
          </Box>
          <Box>
            <Typography
              variant="h1"
              sx={{ color: green[800], fontWeight: "bold" }}
            >
              SUCCESS
            </Typography>
          </Box>
          <Box>
            <Typography fontSize="20px" my="10px" sx={{ color: green[800] }}>
              Your message has been sent!
            </Typography>
          </Box>
        </Box>
      </Paper>
      <Paper
        elevation={12}
        onClick={handleClick}
        sx={{
          background: `linear-gradient(135deg, ${teal[200]} 20%, ${green[200]} 80%)`,
          borderRadius: "20px",
          borderRadius: "20px",
          //   position: "absolute",
          //   bottom: "130px",
          //   left: "50%",
          //   transform: "translateX(-50%)",
          width: "13%",
          cursor: "pointer",
          marginTop: "10px",
          //   zIndex: -1,
        }}
      >
        <Box padding="10px">
          <Typography
            variant="h4"
            // paddingTop="20px"
            sx={{
              color: green[800],
              fontWeight: "bold",
              //   padding: "-8px",
            }}
          >
            Go Back
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default MessageSent;
